export interface ChartThemePalette {
  text: string;
  axis: string;
  surface: string;
  primary: string;
  error: string;
  warning: string;
}

export const CHART_ACCENT_ORANGE = '#fd7e14';
export const CHART_ACCENT_PURPLE = '#6f42c1';
export const CHART_ACCENT_GREEN = '#198754';
export const CHART_ACCENT_GRAY = '#6c757d';

export const CHART_CATEGORY_ACCENTS: readonly string[] = [
  CHART_ACCENT_ORANGE,
  CHART_ACCENT_PURPLE,
  CHART_ACCENT_GREEN,
  CHART_ACCENT_GRAY,
];

export const DONUT_RADIUS: readonly [string, string] = ['48%', '70%'];
export const DONUT_CENTER: readonly [string, string] = ['50%', '44%'];

export function donutSeriesDefaults() {
  return {
    type: 'pie' as const,
    radius: DONUT_RADIUS,
    center: DONUT_CENTER,
    avoidLabelOverlap: true,
    label: { show: false },
    labelLine: { show: false },
  };
}

export function legendBottom(palette: ChartThemePalette) {
  return { show: true, bottom: 0, icon: 'circle', textStyle: { color: palette.text } };
}

export function integerValueAxis(palette: ChartThemePalette) {
  return {
    type: 'value' as const,
    minInterval: 1,
    axisLabel: { color: palette.text },
    axisLine: { lineStyle: { color: palette.axis } },
    splitLine: { lineStyle: { color: palette.axis, opacity: 0.35 } },
  };
}

export function categoryAxis(palette: ChartThemePalette, categories: string[]) {
  return {
    type: 'category' as const,
    data: categories,
    axisLabel: { color: palette.text },
    axisLine: { lineStyle: { color: palette.axis } },
  };
}

export function readChartThemePalette(): ChartThemePalette {
  return {
    text: readAvynaToken('--avyna-color-on-surface'),
    axis: readAvynaToken('--avyna-color-outline-variant'),
    surface: readAvynaToken('--avyna-color-surface'),
    primary: readAvynaToken('--avyna-color-primary'),
    error: readAvynaToken('--avyna-color-error'),
    warning: readAvynaToken('--avyna-color-snackbar-warning-on'),
  };
}

function readAvynaToken(name: string): string {
  return getComputedStyle(document.body).getPropertyValue(name).trim();
}
